import { axiosInventoryInstance } from '@/config/apiConfig';
import axios, { AxiosResponse } from 'axios';
import {
  ICreateUser,
  IDeleteUser,
  IFetchUsers,
  IUser,
} from '@/services/user/user.type';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { IEditUserPayload } from '@/pages/User/user.interface';

export const fetchUsers = ({
  page,
  limit,
  keywords,
  orderBy,
  order,
}: IFetchUsers): Promise<AxiosResponse<IUser, any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.USER.GET_ALL_USERS,
    params: {
      page,
      limit,
      keywords,
      orderBy,
      order,
    },
  });
};
export const fetchUser = (id: number): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.get(`${API_URL_CONFIG.USER.GET_USER}/${id}`);
};

export const createUser = (
  payload: ICreateUser,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.post(
    `${API_URL_CONFIG.USER.CREATE_USER}`,
    payload,
  );
};

export const updateUser = (
  id: string,
  payload: IEditUserPayload,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.USER.CREATE_USER}/${id}`,
    { ...payload },
  );
};

export const deleteUser = (
  id: IDeleteUser,
): Promise<AxiosResponse<IUser, any>> => {
  return axiosInventoryInstance.delete(
    `${API_URL_CONFIG.USER.CREATE_USER}/${id}`,
  );
};
